import { jsx as d } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import I from "./DateFilterCore.js";
import { FilterParam as e } from "../../../../types.js";
import { useMemo as C, useState as O, useCallback as P } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import _ from "../../../../../core/Context/useCoreContext.js";
import { DateRangeFilterParam as T } from "./types.js";
import { EMPTY_OBJECT as A } from "../../../../../utils/value/constants.js";
const L = ({
  timezone: l,
  canResetFilters: s,
  defaultParams: r,
  filters: i,
  nowTimestamp: m,
  refreshNowTimestamp: E,
  sinceDate: u,
  untilDate: R,
  updateFilters: a
}) => {
  const { i18n: o } = _(), t = C(() => o.get(r.current.defaultTimeRange), [o]), [D, c] = O(t), f = P(
    (g = A) => {
      for (const [p, n] of Object.entries(g)) {
        switch (p) {
          case "selectedPresetOption":
            c(n || t);
            break;
          case T.FROM:
            a({
              [e.CREATED_SINCE]: n || r.current.defaultFilterParams[e.CREATED_SINCE]
            });
            break;
          case T.TO:
            a({
              [e.CREATED_UNTIL]: n || r.current.defaultFilterParams[e.CREATED_UNTIL]
            });
            break;
          default:
            return;
        }
        E();
      }
    },
    [t, E, a]
  );
  return C(() => !s && c(t), [s, t]), /* @__PURE__ */ d(
    I,
    {
      label: o.get("dateRange"),
      name: e.CREATED_SINCE,
      sinceDate: u,
      untilDate: R ?? new Date(m).toString(),
      from: i[e.CREATED_SINCE],
      to: i[e.CREATED_UNTIL],
      selectedPresetOption: D,
      timeRangePresetOptions: r.current.timeRangeOptions,
      timezone: l,
      onChange: f,
      showTimezoneInfo: !0,
      now: m
    }
  );
};
export {
  L as default
};
